/* !
 * news.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const thisYear = FUNCTIONS.va.isEnglish ? location.pathname.split('/')[3] : location.pathname.split('/')[2];

	const params = new URLSearchParams(location.search);
	const category = params.get('p_category');
	const page = params.get('rt_bn_news_list_skip');

	const newParams = new URLSearchParams();
	if (category !== null) {
		newParams.set('p_category', category);
	}
	if (page !== null) {
		newParams.set('rt_bn_news_list_skip', page);
	}
	const newSearch = newParams.toString() ? `?${newParams.toString()}` : '';

	const setNewsList = () => {
		const jsonURL = `/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/news${thisYear ? '/' + thisYear : ''}/list.json${newSearch}`;
		const jsonURLirPocket = FUNCTIONS.va.isEnglish ? 'https://xml.irpocket.com/4461/JS/release-enall-all.js' : 'https://xml.irpocket.com/4461/JS/release-all-all.js';
		console.log(jsonURL);

		function loadIRPocket() {
			return new Promise((resolve) => {
				window.ir20handler = function (data) {
					resolve(data.item || []);
				};

				const script = document.createElement('script');
				script.src = jsonURLirPocket;
				script.onerror = () => resolve([]); // 失敗しても空配列
				document.body.appendChild(script);
			});
		}
		async function fetchAndMergeNews() {
			const news1Promise = fetch(jsonURL)
				.then(res => res.ok ? res.json() : [])
				.catch(() => []);

			let news2Promise;
			if (!params.get('p_category') || params.get('p_category') === 'ir_news') {
				news2Promise = loadIRPocket()
			} else {
				news2Promise = [];
			}

			const [data1, data2] = await Promise.all([
				news1Promise,
				news2Promise
			]);

			// 日付キーを統一
			const normalized1 = data1.rt_bn_news_list.map(item => ({ ...item, _date: new Date(item.rt_cf_n_date.datetime) }));
			const normalized2 = data2.map(item => ({ ...item, _date: new Date(item.published) }));
			const merged = [...normalized1, ...normalized2];

			// 降順ソート（新しい順）
			merged.sort((a, b) => b._date - a._date);

			return merged;
		}

		fetchAndMergeNews().then(mergedNews => {
			if (mergedNews.length) {
				Vue.createApp({
					data() {
						return {
							jsonData: mergedNews,
							count: 20
						}
					},
					methods: {
						// IRポケット用
						setDate(published) {
							let date = published?.slice(0, 10) ?? ''
							return date.replace(/-/g, '.');
						},
						newIcon(published) { // 一ヶ月以内ならNEW
							const thisDate = new Date(published);
							const now = new Date();
							const aMonthsAgo = new Date(now);
							aMonthsAgo.setMonth(now.getMonth() - 1);
							return thisDate >= aMonthsAgo && thisDate <= now;
						},

						// CMSoD用
						setBr(content) {
							return content.replace(/\r?\n/g, '<br>');
						},
						setAttachment(item) {
							if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
								return 'nolink';
							} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
								return 'pdf';
							} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
								return 'file';
							} else if (item.rt_cf_n_type3_ext_link_is !== null) {
								return 'blank';
							} else {
								return 'link';
							}
						},
						setTarget(att) {
							if (att === 'link') {
								return '_self';
							} else {
								return '_blank';
							}
						},
						setFilesize(bytes) {
							let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
							if (bytes === 0) {
								return 'n/a';
							}
							let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
							if (i === 0) {
								return bytes + sizes[i];
							}
							return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
						}

					},
					computed: {
						filterItems() {
							let items = this.jsonData;
							let itemsTemp = [];
							let count = this.count;
							if (count > items.length) { count = items.length; }

							// 最新では20件
							if (location.pathname.endsWith('/news/') || location.pathname.endsWith('/news/index.html')) {
								for (let i = 0; i < count; i++) {
									itemsTemp.push(items[i]);
								}
								items = itemsTemp;
							}

							// 年別処理
							itemsTemp = [];
							if (thisYear) {
								items.forEach(ele => {
									if (!ele.published) {
										itemsTemp.push(ele);
									} else if (ele.published && ele.published.slice(0, 4) === thisYear) {
										itemsTemp.push(ele);
									}
								});
								items = itemsTemp;
							}

							return (items);
						}
					}
				}).mount('#vue-app');
			}

			// 年プルダウン
			const yearList = document.querySelector('.js-news-yearList .mod-pulldown-ul');
			const head = document.querySelector('.js-news-yearList summary span');
			let latest = Number(document.querySelector('.js-latest').textContent);
			let earliest = Number(document.querySelector('.js-earliest').textContent);

			// IRポケットあり
			if (!params.get('p_category') || params.get('p_category') === 'ir_news') {
				let latestJson = mergedNews[0]._date.getFullYear();
				let earliestJson = mergedNews[mergedNews.length - 1]._date.getFullYear();
				earliest = earliest < earliestJson ? earliest : earliestJson;
				latest = latest > latestJson ? latest : latestJson;
			}

			for (var i = latest; i >= earliest; i--) {
				let item = yearList.appendChild(document.createElement('li')).appendChild(document.createElement('a'));
				item.setAttribute('href', `${FUNCTIONS.va.isEnglish ? '/english' : ''}/news/${i}/`);
				item.textContent = `${i}年`;
			}

			// 現在年を選択状態にする
			if (thisYear) {
				head.textContent = `${thisYear}${FUNCTIONS.va.isEnglish ? '' : '年'}`;
			} else {
				head.textContent = FUNCTIONS.va.isEnglish ? 'Latest' : '最新';
			}

			// タブカレント
			document.querySelectorAll('.mod-tabMenu a').forEach(ele => {
				if (location.pathname + newSearch === ele.getAttribute('href')) {
					ele.classList.add('is-active');
				}
			});
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		setNewsList();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
